import { render, staticRenderFns } from "./ObjectProgram.vue?vue&type=template&id=1b608e20&scoped=true&"
import script from "./ObjectProgram.vue?vue&type=script&lang=js&"
export * from "./ObjectProgram.vue?vue&type=script&lang=js&"
import style0 from "./ObjectProgram.vue?vue&type=style&index=0&id=1b608e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b608e20",
  null
  
)

export default component.exports